<template>
  <div class="empty">
    <div class="empty-content">
      <div class="empty-image">
        <img :src="types[type][0]"/>
      </div>
      <p class="empty-desc">
        {{desc!==''?desc:types[type][1]}}
      </p>
    </div>

  </div>
</template>

<script>
export default {
  name: "Empty",
  props:{
    type:{
      type:String,
      default:'error'
    },
    desc:{
      type:String,
      default:''
    },
  },
  data(){
    return {
      types:{
        error:[require('@/assets/image/error/requestError.png'),'数据请求失败'],
        notfound:[require('@/assets/image/error/notfound.png'),'页面走丢了'],//404
        network:[require('@/assets/image/error/networkError.png'),'当前网络不可用'],
        forbidden:[require('@/assets/image/error/forbidden.png'),'无权限访问'],//403
        internal:[require('@/assets/image/error/networkError.png'),'系统错误'],//500
        empty:[require('@/assets/image/error/empty.png'),'空空如也'],
        searchEmpty:[require('@/assets/image/error/searchEmpty.png'),'无搜索内容'],
        collectEmpty:[require('@/assets/image/error/collectEmpty.png'),'收藏为空'],
      }
    };
  }
}
</script>

<style scoped>
  .empty{
    display: flex;
    align-items: center;
    justify-content: center;
    padding:15px;
  }
  .empty-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .empty-image{
    width:170px;
  }
  .empty-image img{
    width:100%;
  }
  .empty-desc{
    font-size:16px;
    color:#333333;
    text-align: center;
    padding: 15px 0;
  }
</style>